
export enum StrokeType {
    SOLID = 0,
    DOTTED = 1,
    DASHED = 2
}